import { z } from "zod";
import { DEFAULT_AMOUNT, DISPLAY_ORDER, FEE_CODE, FEE_NAME, STATUS } from "./consts";

export const schema = z.object({
  [FEE_CODE]: z.string().min(1, "This field is required"),
  [FEE_NAME]: z.string().min(1, "This field is required"),
  [DEFAULT_AMOUNT]: z.string().min(1, "This field is required"),
  [STATUS]: z.boolean().optional(),
  [DISPLAY_ORDER]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
